module.exports = {"id":"158956","name":"Julio Alberto Barroso","rating":"75","photo":"./data/images/photos/0/158956.png","club":{"name":"Colo-Colo","logo":"./data/images/clubs/Colo-Colo.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JulioAlbertoBarroso0.json
// module id = 2249
// module chunks = 0